export default {
  oswald: 'Oswald',
  oswald_semibold: 'OswaldSemiBold',
  sfprotext: 'SFProText',
  sfcompact: 'SFCompactText',
  sfcompact_text: 'SFCompactText',
  sfcompact_italic: 'SFCompactTextItalic',
  sfcompact_semibolditalic: 'SFCompactTextSemiBoldItalic',
  sfcompact_bold: 'SFCompactTextBold',
  sfcompact_semibold: 'SFCompactTextSemiBold',
  sfcompact_light: 'SFCompactTextLight',
  oswald_light: 'OswaldLight',
  silkserif_black: 'SilkSerifBlack',
  silkserif_bold: 'SilkSerifBold',
  silkserif_regular: 'SilkSerifRegular'
};
